import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";

import { setCartOffers } from "state/cart-slice";
import { offersState } from "state/offers-slice";
import Offer from "types/Offer";

const useCookieCart = () => {
  const [cookies] = useCookies();
  const dispatch = useDispatch();
  const offers = useSelector(offersState);

  useEffect(() => {
    const storedOfferNames = cookies.CART;
    const allExtraPlanOffers = Object.values(offers?.offersMultiPlanList || {}).flatMap(
      (partnerData) => partnerData.extraPlanOffers,
    );

    const mergedOfferList = [...offers.offersList, ...allExtraPlanOffers];

    const storedOffers = mergedOfferList.filter((offer: Offer) => storedOfferNames?.includes(offer.name));

    dispatch(setCartOffers({ offers: storedOffers }));
  }, [dispatch, cookies.CART, offers.offersList, offers.offersMultiPlanList]);
};

export default useCookieCart;
